import { AZ, AZ_DEFAULT_PROP } from '../constants';
function getAzArgs(azSortProperty) {
  const azProp = `${azSortProperty}.keyword`;
  const AZ_AGGS = {
    aggs: {
      azCount: {
        terms: {
          script: `doc['${azProp}'].getValue().substring(0,1).toUpperCase()`,
          size: 500
        }
      }
    },
    sort: [{
      [azProp]: 'asc'
    }]
  };
  const ALL_AZ_SORT = {
    sort: [{
      _script: {
        type: 'number',
        script: {
          lang: 'painless',
          source: `int charPos = params.letters.indexOf(doc['${azProp}'].value.substring(0,1).toUpperCase()); charPos > -1 ? charPos : 100`,
          params: {
            letters: AZ
          }
        },
        order: 'asc'
      }
    }, {
      [azProp]: 'asc'
    }]
  };
  return {
    ALL_AZ_SORT,
    AZ_AGGS
  };
}
const getExtraAzBits = ({
  shouldReturnAggs,
  isAZ,
  azSortProperty = AZ_DEFAULT_PROP,
  azFilter
}) => {
  if (!isAZ || isAZ && azFilter) return {};
  const {
    AZ_AGGS,
    ALL_AZ_SORT
  } = getAzArgs(azSortProperty);
  if (shouldReturnAggs) return AZ_AGGS;
  return ALL_AZ_SORT;
};
export default getExtraAzBits;
//# sourceMappingURL=get-extra-az-bits.js.map